(function($, w) {
	"use strict";

	var c = w.console;

	if( !$.plugin ) {
		$.plugin = function( pluginname, plugin ) {
			var obj = $.plugin.__extend(pluginname, plugin);

			$.fn[pluginname] = function( action ) {
				var args = arguments;
				if ( typeof(action) === "string" && obj.hasOwnProperty(action) ) {
					return obj[action].apply( $(this), Array.prototype.slice.call( args, 1));
				} else {
					return obj.init.apply( $(this), args );
				}
			};
		};
		
		$.plugin.__extend = function( pluginname, plugin ) {
			function Plugin(pluginname) {
				// Private properties
				var	_storageName = pluginname +".storage",
					_default = {
						settings : { classes : {} },
						storage : {}
					};

				// Private methods
				var	_plugin = function() {
						return $.plugin[pluginname];
					},

					_extendDefault = function( defName, data ) {
						var def = null;

						if( $.plugin[pluginname]._default !== undefined )
						{ def = $.plugin[pluginname]._default[defName]; }

						if( !def ) { return data; }

						return $.extend(true, def, data);
					},

					_settings = function( settings ) {
						var s = _storage.call(this),
							set = s.settings;

						if( !set )
						{ s.settings = set = _extendDefault("settings", {}); }

						if( typeof(settings) === "object" && settings !== null )
						{ s.settings = set = $.extend(true, set, settings); }

						return set;
					},
						
					_storage = function( data, value ) {
						var storedData = this.data(_storageName);

						if( !storedData ) {
							this.data(_storageName, _extendDefault("storage", {}));
							storedData = this.data(_storageName);
						}

						if( typeof(data) === "string" ) {
							if( value === undefined ) {
								return (storedData[data] !== undefined && storedData[data] !== null)? storedData[data] : null;
							}

							storedData[data] = value;

							return storedData[data];
						}

						if( typeof(data) === "object" && data !== null ) {
							data = $.extend(true, storedData, data);
							this.data(_storageName, data);
						}

						return storedData;
					};

				// Global properties
				this.events = function() { return {}; };

				// Global methods
				this.init = function( settings ) {
					return this.each(function(i, elm) {
						_settings.call($(this), settings);
					});
				};
						
				this.settings = function( settings ) {
					var $elm = $(this);

					if( !!settings ) {
						this.each(function(i, elm) {
							_settings.call($elm, settings);
						});
					}
							
					return _settings.call($elm);
				};
						
				this.storage = function( data, value ) {
					if( data === undefined )
					{ return _storage.call(this.eq(0)); }

					/***** Store data before returning *****/

					var storedData;

					this.each(function(i, elm) {
						var sd = _storage.call($(this), data, value);

						if( i === 0 )
						{ storedData = sd; }
					});

					return storedData;
				};

				plugin.apply(this, arguments);
			}

			$.plugin[pluginname] = new Plugin(pluginname);

			return $.plugin[pluginname];
		};
	}
})(jQuery, window);